import { render, staticRenderFns } from "./detailDrawerForOrder.vue?vue&type=template&id=d8be0004&scoped=true"
import script from "./detailDrawerForOrder.vue?vue&type=script&lang=js"
export * from "./detailDrawerForOrder.vue?vue&type=script&lang=js"
import style0 from "./detailDrawerForOrder.vue?vue&type=style&index=0&id=d8be0004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8be0004",
  null
  
)

export default component.exports